import { useEffect } from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'segments/hooks';
import { useNotification } from 'segments/hooks/useNotification';

import { setUserTimezoneToState, selectUserTimzone } from '../store/userSlice';
import { setUserTimezoneToLocalstorage } from '../utils/localStorage';
import { timezoneTitles } from '../utils/timezone';

// import type { UserSettings } from '../store/types';

type TDateType = string | number | Date | dayjs.Dayjs | null | undefined;

const timezoneList: number[] = Object.keys(timezoneTitles).map((timezone) => Number(timezone)).sort((a, b) => a - b);

export interface ITimezone {
  userTimezone: number;
  date(date: TDateType): dayjs.Dayjs;
  commaFormat(date: TDateType): string;
  slashFormat(date: TDateType): string;
}

class Timezone implements ITimezone {
  userTimezone: number;

  constructor(userTimezone: number) {
    this.userTimezone = userTimezone;
  }

  date(date: TDateType): dayjs.Dayjs {
    return dayjs(date).utcOffset(this.userTimezone);
  }

  commaFormat(date: TDateType): string {
    return this.date(date).format('DD.MM.YYYY, HH:mm');
  }

  slashFormat(date: TDateType): string {
    return this.date(date).format('DD.MM.YYYY/ HH:mm');
  }
}

export const useTimezone = (callback?: () => void) => {
  const userTimezone: number = useAppSelector(selectUserTimzone);
  const timezone: ITimezone = new Timezone(userTimezone);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (callback) {
      callback();
    }
  }, [userTimezone]);

  // const {
  //   data: userSettingsData,
  // } = useGetUserSettingsQuery();

  // const [updateUserSettings, {
  //   isSuccess: isUpdateUserSettingsSuccess,
  //   isError: isUpdateUserSettingsError,
  // }] = useUpdateUserSettingsMutation();

  const setTimezone = (timezoneNumber: number) => {
    dispatch(setUserTimezoneToState({ timezone: timezoneNumber }));
  };

  useNotification({
    // isSuccess: isUpdateUserSettingsSuccess,
    successMessage: t('timezone-changed', 'Часовой пояс успешно изменён'),
    // isError: isUpdateUserSettingsError,
  });

  const handleTimezoneChange = async (selectedTimezone: number) => {
    setUserTimezoneToLocalstorage(selectedTimezone);
    setTimezone(selectedTimezone);

    // if (userSettingsData) {
    //   const newUserSettings: UserSettings = {
    //     ...userSettingsData,
    //     timezone: selectedTimezone,
    //   };

    //   await updateUserSettings(newUserSettings);
    // }
  };

  return {
    userTimezone,
    timezone,
    timezoneTitles,
    timezoneList,
    handleTimezoneChange,
  };
};
